import { getCookie } from "services/cookies-service";
import { POSITION_TYPE_CATEGORY_NAME, POSITION_TYPE_INTERNAL_VALUE } from "components/pages/careers/careers-constants";
export const isInternalOnlyPosition = (position)=>{
    var _position_categories;
    const publishCategory = position === null || position === void 0 ? void 0 : (_position_categories = position.categories) === null || _position_categories === void 0 ? void 0 : _position_categories.find((category)=>category.name === POSITION_TYPE_CATEGORY_NAME);
    return (publishCategory === null || publishCategory === void 0 ? void 0 : publishCategory.value) === POSITION_TYPE_INTERNAL_VALUE;
};
export const shouldShowInternalTag = ()=>{
    // Ensure we're on client side
    if (typeof window === 'undefined') {
        return false;
    }
    return getCookie("dapulseLastLoginAccount") === "monday";
};
export const shouldDisplayInternalTag = (position)=>{
    const isInternal = isInternalOnlyPosition(position);
    const shouldShow = shouldShowInternalTag();
    return isInternal && shouldShow;
};
